export default "__VITE_ASSET__KF43$MSK__"